import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function RecommendationForm({ clientId, articles, recent, onSent }) {
  const [msg, setMsg] = useState("");
  const [articleId, setArticleId] = useState("");

  const pickArticle = (id) => {
    setArticleId(id);
    const a = articles.find((x) => x.id === id);
    if (a && !msg.trim()) setMsg(`I think this read might help this week: "${a.title}". Take a look when you have a few minutes.`);
  };

  const send = async (e) => {
    e.preventDefault();
    if (!msg.trim() || !clientId) return;
    await api.post("/clinician/recommendation", { client_id: clientId, message: msg, article_id: articleId || null });
    toast.success(articleId ? "Recommendation and article delivered." : "Recommendation delivered.");
    setMsg("");
    setArticleId("");
    onSent();
  };

  return (
    <form onSubmit={send} className="warm-card p-6">
      <div className="flex items-center gap-2 mb-3">
        <Send className="w-4 h-4 text-emerald-700" />
        <h3 className="font-display font-bold text-stone-900">Send a recommendation</h3>
      </div>
      <textarea data-testid="rec-message" value={msg} onChange={(e) => setMsg(e.target.value)} rows={4}
        placeholder="A gentle nudge, an observation, a reward idea — anything supportive."
        className="w-full px-3 py-2 rounded-xl border border-stone-300 text-sm focus:border-amber-600 focus:ring-2 focus:ring-amber-200 outline-none" />
      <div className="mt-2">
        <label className="text-[10px] font-bold uppercase tracking-widest text-stone-500">Attach a read (optional)</label>
        <select data-testid="rec-article" value={articleId} onChange={(e) => pickArticle(e.target.value)}
          className="mt-1 w-full px-3 py-2 rounded-xl border border-stone-300 text-sm bg-white focus:border-amber-600 outline-none">
          <option value="">No article</option>
          {articles.map((a) => <option key={a.id} value={a.id}>{`${a.title} · ${a.category}`}</option>)}
        </select>
      </div>
      <button data-testid="rec-send" type="submit" className="amber-btn text-sm mt-3">Send</button>
      {recent.length > 0 && (
        <div className="mt-4 pt-4 border-t border-stone-100">
          <div className="text-xs uppercase tracking-widest text-stone-500 font-bold mb-2">Recent</div>
          <ul className="space-y-2 max-h-32 overflow-y-auto">
            {recent.slice(0, 5).map((r) => (
              <li key={r.id} className="text-xs text-stone-600 border-l-2 border-amber-300 pl-2">
                {r.message}
                {r.article_title && <span className="block text-[10px] font-semibold text-emerald-800 mt-0.5">📖 {r.article_title}</span>}
                {r.reminder_time && <span className="block text-[10px] font-semibold text-amber-800 mt-0.5">⏰ {r.reminder_habit_title} at {r.reminder_time}</span>}
                <span className="block text-[10px] font-mono text-stone-400 mt-0.5">{new Date(r.created_at).toLocaleDateString()}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </form>
  );
}
